export default "__VITE_ASSET__7b0761ee__"